import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Story from "@/pages/Story";
import Gallery from "@/pages/Gallery";
import DataCenter from "@/pages/DataCenter";
import Programs from "@/pages/Programs";
import MapPage from "@/pages/MapPage";
import ProjectDetail from "@/pages/ProjectDetail";
import ReportPond from "@/pages/ReportPond";
import Marketplace from "@/pages/Marketplace";
import PaymentResult from "@/pages/PaymentResult";
import Learn from "@/pages/Learn";
import PromisePage from "@/pages/Promise";
import Events from "@/pages/Events";
import Volunteer from "@/pages/Volunteer";
import Partners from "@/pages/Partners";
import Impact from "@/pages/Impact";
import Login from "@/pages/Login";
import Portal from "@/pages/Portal";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/story" element={<Story />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/data" element={<DataCenter />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/map" element={<MapPage />} />
            <Route path="/projects/:code" element={<ProjectDetail />} />
            <Route path="/report" element={<ReportPond />} />
            <Route path="/sponsor" element={<Marketplace />} />
            <Route path="/payment/:result" element={<PaymentResult />} />
            <Route path="/learn" element={<Learn />} />
            <Route path="/promise" element={<PromisePage />} />
            <Route path="/events" element={<Events />} />
            <Route path="/volunteer" element={<Volunteer />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/portal" element={<Portal />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </AuthProvider>
  );
}
